const data = {
  pageName: "NewLineUp",
  services: {
    translations: {
      url: "newlineup/translations",
      params: {}
    },
    offer: {
      url: "offers/offerWeb/offer",
      params: {}
    },
    productDetails: {
      url: "newlineup/productDetails",
      params: {}
    },
    getAssetInfo: {
      url: "offers/offerWeb/getHashedPhoneNumber",
      params: {}
    },
    createServiceRequest: {
      url: "offers/offerWeb/createServiceRequest",
      params: {}
    },
    completeRenewal: {
      url: "offers/offerWeb/completeRenewal",
      params: {}
    },
    checkClickToCallRequest: {
      url: "clickToCall/checkClickToCallRequest",
      params: {}
    },
    checkClickToCallAvailability: {
      url: "clickToCall/checkClickToCallAvailability"
    }
  },
  asset: {
    body: null,
    callinglist: "callingList",
    click2callButtons: "click2callButtons",
    clicktocallid: "clickTocallId",
    clicktocallphone: "clickToCallPhone",
    clicktocallversion: "clickToCallVersion",
    clicktocallcalendar: "clickToCallCalendar",
    formId: "redStart",
    description: "",
    name: "NewLineUpRedStart",
    subtype: "Forms",
    updateddate: "2020-02-26T12:28:46+0000"
  },
  externalLinks: {
    askHelp: "/exypiretisi/my-vodafone/ananeosi-symvolaiou/"
  },
  unlimitedVideoUrl:
    "/app/images/offers/VF_Programmatic_Burst_Commute_Motion.mp4"
};

exports.data = data;
